import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import brandLoader from "../../assets/img/drstrum-loader.gif"

const FullPageLoader = ({isloader}) => {
//   const loaderIcon = <div className="overlay">
// 	<div className="overlayDoor"></div>
// 	<div className="overlayContent">
// 		<div className="loader">
// 			<div className="inner"></div>
// 		</div>		
// 	</div>
// </div>

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: isloader?'flex':'none',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      {/* <Spin indicator={loaderIcon} /> */}
      <img src={brandLoader} className='brandLoader' />
    </div>
  );
};

export default FullPageLoader;
